import ManagePaymentOptions from './ManagePaymentOptions.component';

export default ManagePaymentOptions;
